var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 33.132,
    viewBox: "0 0 24 33.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.888,
    cy: 0.083,
    r: 0.773,
    gradientTransform: "translate(0 -0.06) scale(1 1.648)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#d045e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#7c22e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d08a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#ce7430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ffd9b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c15300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.232,
    y1: 0.163,
    x2: 0.951,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906fe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.583,
    y1: 0.649,
    x2: 0.147,
    y2: 0.912,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#ff9838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#c17935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c66f1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.181,
    y1: 0.314,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc672e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.677,
    y1: 0.052,
    x2: 0.245,
    y2: 0.817,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaa5c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35811",
    x: 12.511,
    y: 12.238,
    width: 10.513,
    height: 10.513,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35820",
    "data-name": "Path 35820",
    d: "M174.648,165.663a14.866,14.866,0,0,1-1.312,1.43,12.082,12.082,0,0,1-14.9-16.154,12.083,12.083,0,0,1,16.209,14.724Z",
    transform: "translate(-157.5 -150)",
    fill: "#fdcb6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.662,
    y2: 0.966,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#c66d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#b15b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673a18"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35769",
    "data-name": "Group 35769",
    transform: "translate(-1 -107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35760",
    "data-name": "Group 35760",
    transform: "translate(1 107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35746",
    "data-name": "Group 35746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35742",
    "data-name": "Group 35742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "first-place",
    transform: "translate(4.868 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35725",
    "data-name": "Group 35725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35789",
    "data-name": "Path 35789",
    d: "M198.179,12.384l-2.029,5.1a.575.575,0,0,1-.535.363H188.8a.575.575,0,0,1-.535-.788l2.389-6.011q.57-.046,1.152-.046A14.159,14.159,0,0,1,198.179,12.384Z",
    transform: "translate(-184.795 -9.996)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35790",
    "data-name": "Path 35790",
    d: "M160.816,90h-8.5a1.818,1.818,0,0,0-1.821,1.811v2.415a1.818,1.818,0,0,0,1.821,1.811h8.5a1.818,1.818,0,0,0,1.821-1.811V91.811A1.818,1.818,0,0,0,160.816,90Zm.607,4.226a.606.606,0,0,1-.607.6h-8.5a.606.606,0,0,1-.607-.6V91.811a.606.606,0,0,1,.607-.6h8.5a.606.606,0,0,1,.607.6Z",
    transform: "translate(-149.355 -84.552)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35791",
    "data-name": "Path 35791",
    d: "M141.845,7.849H133.8a.6.6,0,0,1-.561-.381L130.6.827A.6.6,0,0,1,131.163,0h7.153a.6.6,0,0,1,.561.381Z",
    transform: "translate(-130.558 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35792",
    "data-name": "Path 35792",
    d: "M136.259,7.849H133.8a.6.6,0,0,1-.561-.381L130.6.827A.6.6,0,0,1,131.163,0h1.424L135.5,7.336A.814.814,0,0,0,136.259,7.849Z",
    transform: "translate(-130.534 0)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35735",
    "data-name": "Group 35735",
    transform: "translate(0 9.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35824",
    "data-name": "Path 35824",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_9",
    "data-name": "Exclusion 9",
    d: "M9.5,19A9.5,9.5,0,1,1,19,9.5,9.511,9.511,0,0,1,9.5,19Zm0-16.249A6.75,6.75,0,1,0,16.251,9.5,6.756,6.756,0,0,0,9.5,2.751Z",
    transform: "translate(2.546 2.5)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35808",
    "data-name": "Path 35808",
    d: "M174.648,165.663c-.406.5-.044.923-1.312,1.43a9.617,9.617,0,0,1-3.76.6,12.082,12.082,0,0,1-11.136-16.751,12.083,12.083,0,0,1,16.209,14.724Z",
    transform: "translate(-151.189 -150)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_182",
    "data-name": "Union 182",
    d: "M0,7.049a.952.952,0,0,1,.07-.354h0a.966.966,0,0,1,1.863.353,1.068,1.068,0,1,0,2.016-.492,0,0,0,0,1,0,0A1.07,1.07,0,0,0,3,5.977a.966.966,0,0,1-.829-1.458s0,0,0,0A.964.964,0,0,1,3,4.056,1.066,1.066,0,1,0,1.934,2.99.967.967,0,0,1,0,2.99,3,3,0,1,1,5.2,5.018,2.968,2.968,0,0,1,5.96,6.555v.012A3.142,3.142,0,0,1,6,7.049a3,3,0,1,1-6,0Z",
    transform: "translate(9.151 7.3)",
    fill: "#6e3911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35810",
    "data-name": "Path 35810",
    d: "M172.775,199.66a9.615,9.615,0,0,1-1.736,5.527,12.2,12.2,0,0,1-1.463.088,13.515,13.515,0,0,1-2.306-.212,6.829,6.829,0,0,0-4.154-12.3,7.066,7.066,0,0,0-5.36,2.93,6.125,6.125,0,0,1-.283-1.927,7.9,7.9,0,0,1,.106-1.778A9.87,9.87,0,0,1,163.115,190,9.66,9.66,0,0,1,172.775,199.66Z",
    transform: "translate(-151.227 -187.598)",
    fill: "#ce7430"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -9.13)",
    filter: "url(#Path_35811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35811-2",
    "data-name": "Path 35811",
    d: "M314.16,237.65l-1.058.418a.949.949,0,0,0-.534.534l-.418,1.058a.158.158,0,0,1-.294,0l-.418-1.058a.948.948,0,0,0-.534-.534l-1.058-.418a.158.158,0,0,1,0-.294l1.058-.418a.948.948,0,0,0,.534-.534l.418-1.058a.158.158,0,0,1,.294,0l.418,1.058a.948.948,0,0,0,.534.534l1.058.418A.158.158,0,0,1,314.16,237.65Z",
    transform: "translate(-294.24 -221.01)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_449",
    "data-name": "Mask Group 449",
    transform: "translate(6.311 9.132)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_181",
    "data-name": "Union 181",
    d: "M0,7.049a.952.952,0,0,1,.07-.354h0a.966.966,0,0,1,1.863.353,1.068,1.068,0,1,0,2.016-.492,0,0,0,0,1,0,0A1.07,1.07,0,0,0,3,5.977a.966.966,0,0,1-.829-1.458s0,0,0,0A.964.964,0,0,1,3,4.056,1.066,1.066,0,1,0,1.934,2.99.967.967,0,0,1,0,2.99,3,3,0,1,1,5.2,5.018,2.968,2.968,0,0,1,5.96,6.555v.012A3.142,3.142,0,0,1,6,7.049a3,3,0,1,1-6,0Z",
    transform: "translate(2.84 7.301)",
    fill: "url(#linear-gradient-6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPrize);
export default __webpack_public_path__ + "static/media/third-prize.27d74130f6008cef3cb4600943a68f75.svg";
export { ForwardRef as ReactComponent };